import {
  getPlainTextFromEditor,
  getPlainTextFromSelection,
  isSelected,
  selectAll,
} from '@lyearn/lygo-blocks';
import { EditorView } from '@lyearn/lygo-core';

/**
 * what text to use for ai transformation based on priority:
 *
 * ai suggested text > user selected text > all text
 *
 * NOTE: side effect - if no text is selected, all text will be selected
 * */
export function getInputForTransformation(
  suggestedText: string | null,
  editorView: EditorView,
): string {
  if (suggestedText) {
    return suggestedText;
  }

  if (!isSelected(editorView)) {
    selectAll(editorView);
    return getPlainTextFromEditor(editorView);
  }

  return getPlainTextFromSelection(editorView);
}
